import type { RandomizeState } from '../Randomize/Randomize.model';
import { type Dispatch } from 'react';
import type { ModalProps } from '../../Show';
import { type Animal } from '@/model/Animal.model';
import { type StepFormAction } from '@/components/UI/StepForm/StepForm.model';

export interface RandomizationDateProps {
  state: RandomizeState;
  dispatch: Dispatch<StepFormAction<RandomizeState>>;
  props: ModalProps;
}

export type RDType = 'rd-latest-measurements' | 'rd-specify-date';
export const RDOptions = {
  LatestMeasurements: 'rd-latest-measurements',
  SpecifyDate: 'rd-specify-date',
} as const;
export type RDOptions = (typeof RDOptions)[keyof typeof RDOptions];

export interface ValidateAnimals {
  validationMessages: string[];
  includedAnimals: Animal[];
  excludedAnimals: Animal[];
}
